<iframe [src]="url | safeUrl" frameborder="0" width="100%" height="500px"></iframe>